// import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
// import { connect, useDispatch } from 'react-redux';
// import { getCurrentAction, musicDetailsUpdate, playQueueAction } from '../../Redux/Actions/MusicAction';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import OnlineStatusAlert from '../OnlineStatusAlert';
// import PageLoader from '../Loader/PageLoader';
// import ReactPlayer from 'react-player';
// import { toast } from 'react-toastify';
// import { getItemToken } from '../../Utils/localStorageUtils';
// const MyContext = createContext();
// const MyProvider = ({ isTranslateLoading, siteTheme, thumbnailFreeORCostLabel, children, currentAudio, currentTimes, currentRepeat, currentIndex, playlistAudio, currentPlaying, playlistShow, homepage, languageDetailsData, minimize, playlistData, actionType }) => {

//     const dispatch = useDispatch()
//     // Remove audioRef as we're using ReactPlayer
//     const [currentTime, setCurrentTime] = useState(0);
//     const [duration, setDuration] = useState(0);
//     const [volume, setVolume] = useState(1);
//     const [isPlayerReady, setIsPlayerReady] = useState(false);
//     const [playPauseDebounce, setPlayPauseDebounce] = useState(false);
//     const [searchValue, setSearchValue] = useState('')
//     const [musicSearchValue, setMusicSearchValue] = useState('')
//     const navigate = useNavigate()
//     const [priceData, setPriceData] = useState({
//         loading: true,
//         currentUser: null,
//         ppvPrice: null,
//         defaultCurrency: null,
//         otherCurrency: null
//     });
//     const [isOnline, setIsOnline] = useState(navigator.onLine);
//     const [showOfflineAlert, setShowOfflineAlert] = useState(false);
//     const prograssBarPercentage = (currentTime / 1000 / duration) * 100 || 0;

//     const handlePlayPause = () => {
//         if (!currentAudio || playPauseDebounce) return;

//         // Prevent rapid play/pause calls
//         setPlayPauseDebounce(true);
//         setTimeout(() => setPlayPauseDebounce(false), 300);

//         console.log('🎵 Play/Pause Toggle:', {
//             currentPlaying,
//             isPlayerReady,
//             currentAudio: {
//                 id: currentAudio?.id,
//                 title: currentAudio?.title,
//                 audio_access: currentAudio?.audio_access
//             },
//             action: currentPlaying ? 'PAUSING' : 'PLAYING'
//         });

//         if (currentPlaying) {
//             dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
//         } else {
//             // Only dispatch play if player is ready or we have a valid URL
//             const hasValidUrl = currentAudio?.mp3_url ||
//                 currentAudio?.aac_audio_url ||
//                 currentAudio?.mp3_audio_upload ||
//                 currentAudio?.aac_audio_upload ||
//                 currentAudio?.radio_url ||
//                 currentAudio?.unified_audio_url ||
//                 currentAudio?.stream_url ||
//                 currentAudio?.embed_url;

//             if (hasValidUrl) {
//                 dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
//             } else {
//                 toast.error('No playable audio source available');
//             }
//         }
//     };

//     //custom audio action
//     const playNextLoop = async () => {
//         const nextIndex = (currentIndex + 1) % playlistAudio?.length;
//         if (playlistAudio?.length !== currentIndex + 1 || currentRepeat) {
//             const nextAudio = playlistAudio?.[nextIndex]
//             if (nextAudio?.audio_access) {
//                 await dispatch(getCurrentAction(nextIndex, playlistAudio));
//                 await dispatch(musicDetailsUpdate('AUDIO', playlistAudio?.[nextIndex]?.slug))
//             }
//             else {
//                 dispatch({ type: "PURCHASE_MODAL", payload: true, upComingTitle: nextAudio })
//                 dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
//                 dispatch({ type: "GET_CURRENT_TIME_INDEX", currentTime: 0 });
//             }
//         }
//         else {
//             dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
//             dispatch({ type: "GET_CURRENT_TIME_INDEX", currentTime: 0 });
//         }
//     };

//     const handlePlayNext = async () => {
//         const nextIndex = currentIndex + 1;
//         if (nextIndex < playlistAudio?.length) {
//             const nextAudio = playlistAudio?.[nextIndex]
//             if (nextAudio?.audio_access) {
//                 await dispatch(getCurrentAction(nextIndex, playlistAudio, 0));
//                 dispatch(musicDetailsUpdate("AUDIO", playlistAudio?.[nextIndex]?.slug))
//                 dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
//             }
//             else {
//                 dispatch({ type: "PURCHASE_MODAL", payload: true, upComingTitle: nextAudio })
//             }
//         }
//     };

//     const handlePlayPrev = () => {
//         const nextIndex = currentIndex - 1;
//         if (nextIndex >= 0) {
//             const prevAudio = playlistAudio?.[nextIndex]
//             if (prevAudio?.audio_access) {
//                 dispatch(getCurrentAction(nextIndex, playlistAudio, 0));
//                 dispatch(musicDetailsUpdate('AUDIO', playlistAudio?.[nextIndex]?.slug))
//                 dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
//             }
//             else {
//                 dispatch({ type: "PURCHASE_MODAL", payload: true, upComingTitle: prevAudio })
//             }
//         }
//     };

//     const playerRef = useRef(null);

//     const handleSeek = (newTime) => {
//         const currentMilliSeconds = newTime * 1000;
//         setCurrentTime(currentMilliSeconds);
//         if (playerRef.current && typeof playerRef.current.seekTo === 'function') {
//             playerRef.current.seekTo(newTime, 'seconds');
//         }
//     };
//     const repeatStates = {
//         disabled: 'enabled',
//         enabled: 'currentloop',
//         currentloop: 'disabled'
//     };

//     const handleEnableLoop = () => {
//         dispatch({ type: "GET_REPEAT_SUCCESS", isRepeat: repeatStates[currentRepeat] });
//     };


//     const handleVolume = (newVolume) => {
//         if (typeof newVolume === 'number') {
//             setVolume(newVolume);
//         } else {
//             setVolume((prevVolume) => (prevVolume == 1 ? 0 : 1));
//         }
//     };

//     const handlePlay = (type, slug, id) => {
//         console.log('🎵 HandlePlay called:', { type, slug, id });

//         const isSpecialType = ["PLAYLIST", "ARTIST", "ALBUM", "STATION", "GENRE"].includes(type);

//         if (!isSpecialType) {
//             if (Number(currentAudio?.id) !== Number(id)) {
//                 dispatch(playQueueAction(type, slug));
//                 if (!playlistShow) dispatch({ type: "OPEN_PLAYLIST", payload: true });
//             } else {
//                 handlePlayPause();
//             }
//         } else {
//             if (type !== actionType || playlistData?.id !== id) {
//                 dispatch(playQueueAction(type, slug));
//                 if (!playlistShow) dispatch({ type: "OPEN_PLAYLIST", payload: true });
//             } else {
//                 handlePlayPause();
//             }
//         }
//         dispatch({ type: "GET_ACTION_TYPE", payload: type })
//     }

//     // Audio handlers now managed by ReactPlayer callbacks

//     const onAudioEnded = () => {
//         playNextLoop();
//     };

//     const minimizePlayer = () => {
//         dispatch({ type: "MINIMIZE_PLAYER", payload: !minimize })
//         dispatch({ type: "OPEN_PLAYLIST", payload: minimize })
//         const regex = new RegExp(`^/\\w+/music`);
//         if (!regex.test(window.location.pathname)) {
//             navigate(navigateTranslateChecker(`/music`))
//         }
//     }


//     useEffect(() => {
//         // Reset player ready state when audio changes
//         setIsPlayerReady(false);

//         // PPV gating: if no access, open modal and stop
//         if (currentAudio && Object.keys(currentAudio).length > 0 && currentAudio?.audio_access === false) {
//             dispatch({ type: "PURCHASE_MODAL", payload: true, upComingTitle: currentAudio });
//             dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
//             return;
//         }
//     }, [currentAudio?.id, currentPlaying]);

//     useEffect(() => {
//         if (currentTime !== null) {
//             setCurrentTime(currentTimes);
//             // Seek handled by ReactPlayer in handleSeek
//         }
//     }, [])

//     // Volume is now controlled by ReactPlayer volume prop

//     useEffect(() => {
//         if (currentTime !== null) {
//             dispatch({ type: "GET_LYRIC_SUCCESS", currentTimes: currentTime, });
//         }
//     }, [currentTime]);

//     useEffect(() => {
//         if (playlistShow && homepage !== "home") {
//             navigate(navigateTranslateChecker(`/music/track/${currentAudio?.slug}`))
//         }
//     }, [currentAudio?.id])

//     // ReactPlayer handles HLS and embed sources; no separate HLS attach needed here.

//     const handleSearch = (e) => {
//         setSearchValue(e.target.value)
//         navigate(navigateTranslateChecker(`/search`))
//     }
//     const handleSearchClear = (e) => {
//         setSearchValue('')
//     }
//     const handleMusicSearch = (e) => {
//         setMusicSearchValue(e.target.value)
//         if (window.location.pathname !== navigateTranslateChecker(`/music/search`)) {
//             navigate(navigateTranslateChecker(`/music/search`))
//         }
//     }
//     const handleMusicSearchClear = (e) => {
//         setMusicSearchValue('')
//     }

//     const shufflePlaylist = () => {
//         const shuffledPlaylists = [...playlistAudio];
//         for (let i = shuffledPlaylists.length - 1; i > 0; i--) {
//             const j = Math.floor(Math.random() * (i + 1));
//             [shuffledPlaylists[i], shuffledPlaylists[j]] = [shuffledPlaylists[j], shuffledPlaylists[i]];
//         }
//         dispatch({ type: "GET_AUDIO_SUCCESS", payload: shuffledPlaylists });
//     };
//     useEffect(() => {
//         if (languageDetailsData?.Language_Code === 'ar') {
//             document.body.setAttribute('dir', 'rtl');
//             document.body.classList.add('rtl');
//         } else {

//             document.body.removeAttribute('dir', 'rtl');
//             document.body.classList.remove('rtl');
//         }
//     }, [languageDetailsData])

//     const fetchCurrencyData = async () => {
//         try {
//             const { data } = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Currency-Index`, {
//                 headers: getItemToken('access_token') || {
//                     'guestverfiykey': "WebVodWebnexs",
//                     'Content-Type': 'application/json',
//                 }
//             });

//             const defaultCurrency = data?.CurrencySetting;
//             const allCurrency = data?.allCurrency;

//             setPriceData(prev => ({
//                 ...prev,
//                 defaultCurrency,
//                 otherCurrency: allCurrency
//             }));

//             // call fetchUserLocation with allCurrency and defaultCurrency
//             fetchUserLocation(defaultCurrency?.code, allCurrency);
//         } catch (error) {
//             console.error('Error fetching currency data:', error);
//         }
//     };

//     const fetchUserLocation = async (defaultCurrencyCode, allCurrency) => {
//         try {
//             const { data: locationData } = await axios.get(`${process.env.REACT_APP_API_IP_Location}`);

//             // Find once and reuse
//             const matchedCurrency = allCurrency?.find(item => item?.country === locationData?.country);

//             setPriceData(prev => ({
//                 ...prev,
//                 currentUser: locationData,
//                 convertSymbol: matchedCurrency?.symbol
//             }));

//             exchangePrice(locationData, defaultCurrencyCode, matchedCurrency?.code);
//         } catch (error) {
//             console.error('Error fetching location data:', error);
//         }
//     };


//     const exchangePrice = async (userLocation, currencyCode, selectedCurrency) => {
//         try {
//             const { data: rateData } = await axios.get(`${process.env.REACT_APP_API_Curreny_generate}/${currencyCode}`);
//             if (selectedCurrency) {
//                 setPriceData(prev => ({
//                     ...prev,
//                     ppvPrice: rateData?.rates[selectedCurrency],
//                     loading: false,
//                 }));
//             } else {
//                 console.error('Selected currency not found for user location.');
//                 setPriceData(prev => ({
//                     ...prev,
//                     ppvPrice: null,
//                     loading: false,
//                 }));
//             }
//         } catch (error) {
//             console.error('Error fetching exchange price:', error);
//         }
//     };

//     const navigateTranslateChecker = (path) => {
//         if (siteTheme?.translate_checkout) {
//             return `/${languageDetailsData?.Language_Code}${path}`
//         }
//         else {
//             return `${path}`
//         }
//     }

//     useEffect(() => {
//         if (thumbnailFreeORCostLabel) {
//             fetchCurrencyData();
//         }
//     }, [thumbnailFreeORCostLabel]);

//     useEffect(() => {
//         const handleOnline = () => {
//             setIsOnline(true);
//             setShowOfflineAlert(true);
//             setTimeout(() => {
//                 setShowOfflineAlert(false);
//             }, 5000);
//         };

//         const handleOffline = () => {
//             setIsOnline(false);
//             setShowOfflineAlert(true);
//         };

//         window.addEventListener('online', handleOnline);
//         window.addEventListener('offline', handleOffline);

//         return () => {
//             window.removeEventListener('online', handleOnline);
//             window.removeEventListener('offline', handleOffline);
//         };
//     }, []);

//     const reload = () => {
//         setShowOfflineAlert(true)
//         window.location.reload()
//     }
//     return (
//         <MyContext.Provider value={{ isOnline, navigateTranslateChecker, priceData, shufflePlaylist, handleMusicSearch, handleMusicSearchClear, handleSearchClear, handlePlayPause, handlePlayNext, handlePlayPrev, handleVolume, handleSeek, handleEnableLoop, minimizePlayer, handlePlay, prograssBarPercentage, duration, currentTime, volume, handleSearch, searchValue, musicSearchValue }}>
//             {currentAudio ? (
//                 <ReactPlayer
//                     ref={playerRef}
//                     url={(() => {
//                         if (!currentAudio?.audio_access) return null;

//                         // Simple URL extraction that prioritizes radio_url
//                         let url = currentAudio?.radio_url ||
//                             currentAudio?.stream_url ||
//                             currentAudio?.mp3_url ||
//                             currentAudio?.aac_audio_url ||
//                             currentAudio?.mp3_audio_upload ||
//                             currentAudio?.aac_audio_upload ||
//                             currentAudio?.unified_audio_url;

//                         // If it's an iframe, try to extract the src URL
//                         if (url && url.includes('<iframe')) {
//                             const srcMatch = url.match(/src=["']([^"']+)["']/);
//                             if (srcMatch) {
//                                 url = srcMatch[1];
//                                 console.log('🎵 Extracted URL from iframe:', url);
//                             }
//                         }

//                         console.log('🎵 ReactPlayer URL:', {
//                             title: currentAudio?.title,
//                             selectedUrl: currentAudio?.radio_url,
//                             radio_url: currentAudio?.radio_url,
//                             stream_url: currentAudio?.stream_url,
//                             source_type: currentAudio?.source_type
//                         });

//                         return currentAudio?.radio_url;
//                     })()}
//                     playing={Boolean(currentPlaying && currentAudio?.audio_access !== false && currentAudio?.id)}
//                     controls={false}
//                     volume={volume}
//                     muted={volume === 0}
//                     width="0"
//                     height="0"
//                     config={{
//                         file: {
//                             forceAudio: true,
//                             attributes: {
//                                 preload: 'metadata',
//                                 crossOrigin: 'anonymous'
//                             }
//                         },
//                         youtube: {
//                             playerVars: {
//                                 autoplay: 0,
//                                 controls: 0,
//                                 modestbranding: 1
//                             }
//                         },
//                         soundcloud: {
//                             options: {
//                                 auto_play: false,
//                                 buying: false,
//                                 download: false
//                             }
//                         }
//                     }}
//                     onProgress={({ playedSeconds }) => {
//                         setCurrentTime(playedSeconds * 1000);
//                     }}
//                     onDuration={setDuration}
//                     onEnded={onAudioEnded}
//                     onReady={() => {
//                         console.log('🎆 ReactPlayer ready for:', currentAudio?.title);
//                         setIsPlayerReady(true);
//                         // ReactPlayer is ready to play - maintain current playing state
//                         if (currentPlaying && currentAudio?.audio_access !== false && currentAudio?.id) {
//                             console.log('▶️ Auto-starting playback...');
//                         }
//                     }}
//                     onPlay={() => {
//                         console.log('▶️ ReactPlayer started playing:', currentAudio?.title);
//                         dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: true });
//                     }}
//                     onPause={() => {
//                         console.log('⏸️ ReactPlayer paused:', currentAudio?.title);
//                         dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });
//                     }}
//                     onError={(error, data, hlsInstance, hlsGlobal) => {
//                         const currentUrl = (() => {
//                             if (!currentAudio?.audio_access) return null;
//                             return currentAudio?.radio_url
//                         })();

//                         console.error('🚨 ReactPlayer Error Details:', {
//                             error,
//                             data,
//                             currentUrl,
//                             currentAudio: currentAudio?.title,
//                             errorType: error?.type,
//                             errorMessage: error?.message
//                         });

//                         dispatch({ type: "GET_PLAYING_SUCCESS", isPlaying: false });

//                         // Provide specific error messages
//                         let errorMsg = 'Cannot play this audio source';
//                         if (currentUrl && currentUrl.includes('<iframe')) {
//                             errorMsg = 'This radio station uses an embed player that cannot be controlled by the floating player';
//                         } else if (currentUrl && currentUrl.includes('iono.fm')) {
//                             errorMsg = 'Radio stream temporarily unavailable - please try again later';
//                         } else if (error?.message) {
//                             errorMsg = error.message;
//                         }

//                         toast.error(`${currentAudio?.title}: ${errorMsg}`);
//                     }}
//                 />
//             ) : null}
//             {siteTheme?.translate_checkout ? isTranslateLoading &&
//                 <></>
//                 // <PageLoader className="position-fixed loaderFixed  vicky d-flex align-items-center justify-content-center min-vh-100" />
//                 : null}
//             {showOfflineAlert ? <OnlineStatusAlert reload={reload} /> : !isOnline && <OnlineStatusAlert reload={reload} />}
//             {children}
//         </MyContext.Provider >)
// }

// const mapStateToProps = state => ({
//     currentAudio: state.get_current_Reducers.currentAudio,
//     currentTimes: state.get_current_Reducers.currentTime,
//     currentRepeat: state.get_current_Reducers.currentRepeat,
//     playlistAudio: state.get_playlist_Reducer.playlistAudio,
//     isLoading: state.get_playlist_Reducer.isLoading,
//     error: state.get_playlist_Reducer.error,
//     currentIndex: state.get_current_Reducers.currentIndex,
//     currentPlaying: state.get_current_Reducers.currentPlaying,
//     playlistShow: state.get_Playlist_Modal.playlistShow,
//     homepage: state.get_Playlist_Modal.homepage,
//     languageDetailsData: state.get_getUserTranslateLanguage_Reducer.languageDetailsData,
//     minimize: state.get_Playlist_Modal.minimize,
//     playlistData: state.get_current_Reducers.playlistData,
//     actionType: state.get_current_Reducers.actionType,
//     thumbnailFreeORCostLabel: state.get_allThumbnail_Reducer.thumbnailFreeORCostLabel,
//     siteTheme: state.get_siteTheme_Reducer.siteTheme,
//     isTranslateLoading: state.get_getUserTranslateLanguage_Reducer.isLoading,
// });
// export default connect(mapStateToProps)(MyProvider);

// export function useMyContext() {
//     return useContext(MyContext);
// }



import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { getCurrentAction, musicDetailsUpdate, playQueueAction } from '../../Redux/Actions/MusicAction';
import { userPermissionAction } from '../../Redux/Actions/apiActions';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import OnlineStatusAlert from '../OnlineStatusAlert';
import { getItemToken } from '../../Utils/localStorageUtils';
import { useTranslation } from "react-i18next";
// import SimpleWorkingPlayer from '../SimpleWorkingPlayer';

const MyContext = createContext();

const MyProvider = ({
    isTranslateLoading,
    siteTheme,
    thumbnailFreeORCostLabel,
    children,
    currentAudio,
    currentTimes,
    currentRepeat,
    currentIndex,
    playlistAudio,
    currentPlaying,
    playlistShow,
    homepage,
    languageDetailsData,
    minimize,
    playlistData,
    actionType,
    onlyPermission
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();


    // Add playerRef for HTML5 audio element
    const playerRef = useRef(null);
    const [isPlayerReady, setIsPlayerReady] = useState(false);

    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(() => {
        const savedVolume = localStorage.getItem('audio_volume');
        return savedVolume ? parseFloat(savedVolume) : 0.7; // default 0.7 per user request assessment
    });
    const audioContextRef = useRef(null);
    const gainNodeRef = useRef(null);
    const sourceNodeRef = useRef(null);
    const [playPauseDebounce, setPlayPauseDebounce] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [musicSearchValue, setMusicSearchValue] = useState('');
    const baseURL = process.env.REACT_APP_Baseurl;
    const [priceData, setPriceData] = useState({
        loading: true,
        currentUser: null,
        ppvPrice: null,
        defaultCurrency: null,
        otherCurrency: null
    });
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showOfflineAlert, setShowOfflineAlert] = useState(false);
    const [isShuffle, setIsShuffle] = useState(false);

    const prograssBarPercentage = (currentTime / 1000 / duration) * 100 || 0;
    // console.log(currentAudio, "currentAudio")
    // console.log(currentPlaying, "currentPlaying")

    const isSameOriginMediaUrl = url => {
        try {
            return new URL(url, window.location.href).origin === window.location.origin;
        } catch (_) {
            return false;
        }
    };

    const isBackendManagedAudioUrl = url => {
        if (!url) return false;
        return url.includes('/play-audio/') || (baseURL && url.startsWith(baseURL));
    };

    const shouldUseAnonymousCorsForAudio = url => {
        if (!url) return false;

        // Relative URLs and backend-proxy URLs are safe for WebAudio/CORS mode.
        if (!/^https?:\/\//i.test(url)) return true;

        return isSameOriginMediaUrl(url) || isBackendManagedAudioUrl(url);
    };

    /** ----------- Play/Pause - Simplified for WorkingRadioPlayer ----------- */
    const handlePlayPause = () => {
        if (!currentAudio || playPauseDebounce) return;

        setPlayPauseDebounce(true);
        setTimeout(() => setPlayPauseDebounce(false), 300);

        // console.log('🎵 Play/Pause clicked - Dispatching to Redux, WorkingRadioPlayer will sync');
        // console.log('🎵 Current audio:', currentAudio?.title);
        // console.log('🎵 Current playing state:', currentPlaying);

        // If we are about to play (!currentPlaying), ensure the player is visible
        if (!currentPlaying) {
            dispatch({ type: "GET_CLOSE_SUCCESS", isClose: true });
        }

        // Initialize Web Audio API on first interaction
        if (!audioContextRef.current && window.AudioContext) {
            try {
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                gainNodeRef.current = audioContextRef.current.createGain();
                gainNodeRef.current.connect(audioContextRef.current.destination);

                // Initial volume set
                gainNodeRef.current.gain.value = volume;

                console.log('🔊 AudioContext and GainNode initialized');
            } catch (err) {
                console.error('❌ Failed to initialize AudioContext:', err);
            }
        } else if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
            audioContextRef.current.resume();
        }

        // Toggle the Redux playing state - WorkingRadioPlayer will respond to this change
        dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: !currentPlaying });
    };

    const playNextLoop = async () => {
        if (currentRepeat === 'currentloop') {
            setCurrentTime(0);
            dispatch({ type: 'GET_CURRENT_TIME_INDEX', currentTime: 0 });
            if (playerRef.current) {
                playerRef.current.currentTime = 0;
                playerRef.current.play().catch(e => console.error(e));
            }
            return;
        }

        const nextIndex = (currentIndex + 1) % playlistAudio?.length;
        if (playlistAudio?.length !== currentIndex + 1 || currentRepeat === 'enabled') {
            const nextAudio = playlistAudio?.[nextIndex];
            if (nextAudio?.audio_access) {
                await dispatch(getCurrentAction(nextIndex, playlistAudio));
                await dispatch(musicDetailsUpdate('AUDIO', playlistAudio?.[nextIndex]?.slug));
            } else {
                dispatch({ type: 'PURCHASE_MODAL', payload: true, upComingTitle: nextAudio });
                dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: false });
                dispatch({ type: 'GET_CURRENT_TIME_INDEX', currentTime: 0 });
            }
        } else {
            dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: false });
            dispatch({ type: 'GET_CURRENT_TIME_INDEX', currentTime: 0 });
        }
    };

    const handlePlayNext = async () => {
        const nextIndex = currentIndex + 1;
        if (nextIndex < playlistAudio?.length) {
            const nextAudio = playlistAudio?.[nextIndex];
            if (nextAudio?.audio_access) {
                await dispatch(getCurrentAction(nextIndex, playlistAudio, 0));
                dispatch(musicDetailsUpdate('AUDIO', playlistAudio?.[nextIndex]?.slug));
                dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: true });
            } else {
                dispatch({ type: 'PURCHASE_MODAL', payload: true, upComingTitle: nextAudio });
            }
        }
    };

    const handlePlayPrev = () => {
        const nextIndex = currentIndex - 1;
        if (nextIndex >= 0) {
            const prevAudio = playlistAudio?.[nextIndex];
            if (prevAudio?.audio_access) {
                dispatch(getCurrentAction(nextIndex, playlistAudio, 0));
                dispatch(musicDetailsUpdate('AUDIO', playlistAudio?.[nextIndex]?.slug));
                dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: true });
            } else {
                dispatch({ type: 'PURCHASE_MODAL', payload: true, upComingTitle: prevAudio });
            }
        }
    };

    const handleSeek = newTime => {
        const currentMilliSeconds = newTime * 1000;
        setCurrentTime(currentMilliSeconds);
        if (playerRef.current) {
            playerRef.current.currentTime = newTime;
        }
    };

    const repeatStates = {
        disabled: 'enabled',
        enabled: 'currentloop',
        currentloop: 'disabled'
    };

    const handleEnableLoop = () => {
        dispatch({ type: 'GET_REPEAT_SUCCESS', isRepeat: repeatStates[currentRepeat] });
    };

    const handleVolume = newVolume => {
        let volumeValue;
        if (typeof newVolume === 'number') {
            volumeValue = newVolume;
        } else if (newVolume?.target?.value !== undefined && newVolume.target.value !== "") {
            volumeValue = parseFloat(newVolume.target.value);
        } else {
            volumeValue = volume > 0 ? 0 : 1;
        }

        if (Number.isFinite(volumeValue)) {
            setVolume(volumeValue);
            localStorage.setItem('audio_volume', volumeValue);

            // Set gain for boost (above 1.0)
            if (gainNodeRef.current) {
                gainNodeRef.current.gain.setTargetAtTime(volumeValue, audioContextRef.current.currentTime, 0.01);
            }

            // Standard volume property capped at 1.0 for the audio element itself
            if (playerRef.current) {
                playerRef.current.volume = Math.min(volumeValue, 1.0);
            }
        }
    };

    const handlePlay = (type, slug, id) => {
        // Ensure player is visible when playing
        dispatch({ type: 'GET_CLOSE_SUCCESS', isClose: true });

        const isSpecialType = ['PLAYLIST', 'ADMIN_PLAYLIST', 'ARTIST', 'ALBUM', 'STATION', 'GENRE'].includes(type);

        if (!isSpecialType) {
            if (Number(currentAudio?.id) !== Number(id)) {
                dispatch(playQueueAction(type, slug));
                if (!playlistShow) dispatch({ type: 'OPEN_PLAYLIST', payload: true });
            } else {
                handlePlayPause();
            }
        } else {
            if (type !== actionType || playlistData?.id !== id) {
                dispatch(playQueueAction(type, slug));
                if (!playlistShow) dispatch({ type: 'OPEN_PLAYLIST', payload: true });
                // Radio stations have a dedicated detail page (not a /music/track page),
                // so always land there when starting playback, regardless of the
                // legacy `homepage` gate that otherwise controls the track-page redirect.
                if (type === 'STATION') {
                    navigate(navigateTranslateChecker(`/music/radio/station/${slug}`));
                }
            } else {
                handlePlayPause();
            }
        }
        dispatch({ type: 'GET_ACTION_TYPE', payload: type });
    };

    const onAudioEnded = () => {
        playNextLoop();
    };

    const minimizePlayer = () => {
        dispatch({ type: 'MINIMIZE_PLAYER', payload: !minimize });
        dispatch({ type: 'OPEN_PLAYLIST', payload: minimize });
        const regex = new RegExp(`^/\\w+/music`);
        if (!regex.test(window.location.pathname)) {
            navigate(navigateTranslateChecker(`/music`));
        }
    };

    /** ----------- Effects ----------- */
    // Control HTML5 audio element play/pause
    useEffect(() => {
        if (!playerRef.current) return;

        if (currentPlaying) {
            playerRef.current.play().catch(err => {
                console.error('▶️ Play failed:', err);
            });
        } else {
            playerRef.current.pause();
        }
    }, [currentPlaying]);

    // Control HTML5 audio element volume and boost
    useEffect(() => {
        if (!playerRef.current) return;

        // Sync volume property (capped at 1.0)
        playerRef.current.volume = Math.min(volume, 1.0);

        // Sync gain property if initialized
        if (gainNodeRef.current && audioContextRef.current) {
            gainNodeRef.current.gain.setTargetAtTime(volume, audioContextRef.current.currentTime, 0.01);
        }
    }, [volume]);

    useEffect(() => {
        // Handle access control
        if (currentAudio && Object.keys(currentAudio).length > 0 && currentAudio?.audio_access === false) {
            dispatch({ type: 'PURCHASE_MODAL', payload: true, upComingTitle: currentAudio });
            dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: false });
        }
    }, [currentAudio?.id, currentPlaying]);

    useEffect(() => {
        if (currentTime !== null) {
            setCurrentTime(currentTimes);
        }
    }, []);

    useEffect(() => {
        if (currentTime !== null) {
            dispatch({ type: 'GET_LYRIC_SUCCESS', currentTimes: currentTime });
        }
    }, [currentTime]);

    useEffect(() => {
        if (sourceNodeRef.current) {
            try {
                sourceNodeRef.current.disconnect();
            } catch (_) {
                // Ignore disconnect errors from stale media nodes.
            }
            sourceNodeRef.current = null;
        }
    }, [currentAudio?.id, currentAudio?.slug]);

    useEffect(() => {
        dispatch(userPermissionAction());
    }, [dispatch]);

    useEffect(() => {
        if (playlistShow && homepage !== 'home') {
            if (actionType === 'STATION') {
                navigate(navigateTranslateChecker(`/music/radio/station/${currentAudio?.slug}`));
            } else {
                navigate(navigateTranslateChecker(`/music/track/${currentAudio?.slug}`));
            }
        }
    }, [currentAudio?.id]);

    useEffect(() => {
        if (languageDetailsData?.Language_Code === 'ar') {
            document.body.setAttribute('dir', 'rtl');
            document.body.classList.add('rtl');
        } else {
            document.body.removeAttribute('dir', 'rtl');
            document.body.classList.remove('rtl');
        }
    }, [languageDetailsData]);

    // WorkingRadioPlayer handles all URL processing and audio playback
    /** ----------- MediaSession Integration (Chrome/System controls) ----------- */
    useEffect(() => {
        if ('mediaSession' in navigator && currentAudio) {
            // Priority for artist name: album_artist_name -> artist_name -> default
            const artistName = currentAudio?.album_artist_name || currentAudio?.artist_name;

            // Priority for image: image_URL -> Thumbnail -> image
            const artworkUrl = currentAudio?.image_URL || currentAudio?.Thumbnail || currentAudio?.image;

            // console.log('📽️ Updating MediaSession Metadata:', {
            //     title: currentAudio?.title,
            //     artist: artistName,
            //     artwork: artworkUrl
            // });

            navigator.mediaSession.metadata = new window.MediaMetadata({
                title: currentAudio?.title,
                artist: artistName,
                album: currentAudio?.track_name,
                artwork: artworkUrl ? [
                    { src: artworkUrl, sizes: '96x96', type: 'image/webp' },
                    { src: artworkUrl, sizes: '128x128', type: 'image/webp' },
                    { src: artworkUrl, sizes: '192x192', type: 'image/webp' },
                    { src: artworkUrl, sizes: '256x256', type: 'image/webp' },
                    { src: artworkUrl, sizes: '384x384', type: 'image/webp' },
                    { src: artworkUrl, sizes: '512x512', type: 'image/webp' },
                ] : []
            });

            // Sync Playback State
            navigator.mediaSession.playbackState = currentPlaying ? "playing" : "paused";

            // Register Action Handlers for System keys
            navigator.mediaSession.setActionHandler('play', () => {
                if (!currentPlaying) handlePlayPause();
            });
            navigator.mediaSession.setActionHandler('pause', () => {
                if (currentPlaying) handlePlayPause();
            });
            navigator.mediaSession.setActionHandler('previoustrack', () => {
                handlePlayPrev();
            });
            navigator.mediaSession.setActionHandler('nexttrack', () => {
                handlePlayNext();
            });
        }
    }, [currentAudio?.id, currentPlaying]);

    const fetchCurrencyData = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_Baseurl}/Front-End/Currency-Index`, {
                headers: getItemToken('access_token') || {
                    guestverfiykey: 'WebVodWebnexs',
                    'Content-Type': 'application/json'
                }
            });

            const defaultCurrency = data?.CurrencySetting;
            const allCurrency = data?.allCurrency;

            setPriceData(prev => ({
                ...prev,
                defaultCurrency,
                otherCurrency: allCurrency
            }));

            fetchUserLocation(defaultCurrency?.code, allCurrency);
        } catch (error) {
            console.error('Error fetching currency data:', error);
        }
    };

    const fetchUserLocation = async (defaultCurrencyCode, allCurrency) => {
        try {
            const { data: locationData } = await axios.get(`${process.env.REACT_APP_API_IP_Location}`);
            const matchedCurrency = allCurrency?.find(item => item?.country === locationData?.country);

            setPriceData(prev => ({
                ...prev,
                currentUser: locationData,
                convertSymbol: matchedCurrency?.symbol
            }));

            exchangePrice(locationData, defaultCurrencyCode, matchedCurrency?.code);
        } catch (error) {
            console.error('Error fetching location data:', error);
        }
    };

    const exchangePrice = async (userLocation, currencyCode, selectedCurrency) => {
        try {
            const { data: rateData } = await axios.get(
                `${process.env.REACT_APP_API_Curreny_generate}/${currencyCode}`
            );
            if (selectedCurrency) {
                setPriceData(prev => ({
                    ...prev,
                    ppvPrice: rateData?.rates[selectedCurrency],
                    loading: false
                }));
            } else {
                setPriceData(prev => ({
                    ...prev,
                    ppvPrice: null,
                    loading: false
                }));
            }
        } catch (error) {
            console.error('Error fetching exchange price:', error);
        }
    };

    const navigateTranslateChecker = (path) => {
        if (!path || typeof path !== 'string') return path;
        if (Number(siteTheme?.translate_checkout) === 1) {
            const langCode = languageDetailsData?.Language_Code || 'en';

            // Check if it's already an absolute URL
            if (path.startsWith('http://') || path.startsWith('https://')) {
                return path;
            }

            // Ensure the path starts with a slash for consistent prefixing
            let normalizedPath = path.startsWith('/') ? path : `/${path}`;

            // Cross-language protection: If the path already starts with a DIFFERENT language prefix (e.g. /en/home),
            // we should strip it before adding the current one (e.g. /de/home).
            // This prevents malformed URLs like /de/en/home.
            const genericLangRegex = /^\/([a-z]{2,3})(\/|$)/i;
            const match = normalizedPath.match(genericLangRegex);
            if (match && match[1].toLowerCase() !== langCode.toLowerCase()) {
                normalizedPath = normalizedPath.replace(/^\/[a-z]{2,3}/i, '');
                if (!normalizedPath.startsWith('/')) normalizedPath = '/' + normalizedPath;
            }

            // Check if the normalized path already starts with the language prefix (e.g., /en/ or /en$)
            const prefix = `/${langCode}`;

            // Deduplicate: If the path already contains a doubled prefix, collapse it first (e.g. /tr/tr -> /tr)
            const doublePrefix = `${prefix}${prefix}`;
            if (normalizedPath.startsWith(`${doublePrefix}/`)) {
                normalizedPath = normalizedPath.replace(`${doublePrefix}/`, `${prefix}/`);
            } else if (normalizedPath === doublePrefix) {
                normalizedPath = prefix;
            }

            if (normalizedPath === prefix || normalizedPath.startsWith(`${prefix}/`)) {
                return normalizedPath;
            }

            return `${prefix}${normalizedPath}`;
        } else {
            return path;
        }
    };


    useEffect(() => {
        if (thumbnailFreeORCostLabel) {
            fetchCurrencyData();
        }
    }, [thumbnailFreeORCostLabel]);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowOfflineAlert(true);
            setTimeout(() => {
                setShowOfflineAlert(false);
            }, 5000);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowOfflineAlert(true);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const reload = () => {
        setShowOfflineAlert(true);
        window.location.reload();
    };

    const fetchRequest = async ({ method, url, params = {}, data = {}, headers = {}, signal, timeout = 0 }) => {
        try {
            const token = localStorage.getItem('access_token');
            const guestHeader = !token ? { guestverfiykey: "WebVodWebnexs" } : {};
            const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
            const config = {
                method,
                url,
                params,
                data,
                signal,
                timeout,
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                headers: {
                    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
                    ...(token ? { Authorization: `Bearer ${token}` } : {}),
                    ...guestHeader,
                    ...headers
                }
            };
            const response = await axios(config);
            return response?.data;
        } catch (error) {
            throw error;
        }
    };
    function getDeviceMachineId() {
        let machineId = localStorage.getItem("device_machine_id");

        if (!machineId) {
            machineId = crypto.randomUUID(); // generates a unique device ID
            localStorage.setItem("device_machine_id", machineId);
        }

        return machineId;
    }


    const globalFrontendImageUplaodAPI = () => `${baseURL}/Front-end/frontend-global-image-uploads`;

    const shufflePlaylist = () => {
        if (!playlistAudio || playlistAudio.length === 0) return;

        if (isShuffle) {
            // Restore original order
            setIsShuffle(false);
            dispatch({ type: "RESTORE_ORIGINAL_PLAYLIST" });
        } else {
            // Enable shuffle
            setIsShuffle(true);
            const shuffledPlaylists = [...playlistAudio];
            // Fisher-Yates shuffle
            for (let i = shuffledPlaylists.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [shuffledPlaylists[i], shuffledPlaylists[j]] = [shuffledPlaylists[j], shuffledPlaylists[i]];
            }

            // Dispatch shuffled list to Redux (using specialized action)
            dispatch({ type: "GET_AUDIO_SUCCESS_SHUFFLED", payload: shuffledPlaylists });

            // Update current index for the new shuffled list
            if (currentAudio && currentAudio.id) {
                const newIndex = shuffledPlaylists.findIndex(item => String(item.id) === String(currentAudio.id));
                if (newIndex !== -1) {
                    dispatch({ type: "GET_CURRENT_INDEX", currentIndex: newIndex });
                }
            }
        }
    };

    return (
        <MyContext.Provider
            value={{
                isOnline,
                isShuffle,
                navigateTranslateChecker,
                priceData,
                shufflePlaylist,
                handleMusicSearch: e => {
                    setMusicSearchValue(e.target.value);
                    if (window.location.pathname !== navigateTranslateChecker(`/music/search`)) {
                        navigate(navigateTranslateChecker(`/music/search`));
                    }
                },
                handleMusicSearchClear: () => setMusicSearchValue(''),
                handleSearchClear: () => setSearchValue(''),
                handlePlayPause,
                handlePlayNext,
                handlePlayPrev,
                handleVolume,
                handleSeek,
                handleEnableLoop,
                minimizePlayer,
                handlePlay,
                prograssBarPercentage,
                duration,
                currentTime,
                volume,
                handleSearch: e => {
                    setSearchValue(e.target.value);
                    navigate(navigateTranslateChecker(`/search`));
                },
                searchValue,
                musicSearchValue,
                fetchRequest,
                globalFrontendImageUplaodAPI,
                getDeviceMachineId,
                handlePlayPause,
                onlyPermission
            }}
        >
            {/* HTML5 Native Audio Player - Replaces ReactPlayer for better reliability */}
            {currentAudio && (() => {
                // Fix: Only block if audio_access is explicitly false
                if (currentAudio?.audio_access === false) {
                    console.warn('🚫 Playback blocked: audio_access is false');
                    return null;
                }

                // Get audio URL based on type
                let audioUrl = null;

                // For radio stations
                if (currentAudio?.source_type === 'RADIO' || actionType === 'STATION') {
                    // PRIORITY #1: Check for direct audio URLs FIRST (radio_URL, stream_url, mp3, etc.)
                    // If a direct audio URL exists, use HTML5 audio player instead of iframe
                    audioUrl = currentAudio?.radio_URL ||
                        currentAudio?.radio_url ||
                        currentAudio?.stream_url ||
                        currentAudio?.unified_audio_url ||
                        currentAudio?.mp3_audio_upload ||
                        currentAudio?.aac_audio_upload ||
                        currentAudio?.mp3_url ||
                        currentAudio?.aac_audio_url ||
                        currentAudio?.audio_url;

                    // If we found a direct audio URL, check if it's actually a direct stream (not iframe HTML)
                    if (audioUrl && !audioUrl.includes('<iframe') && !audioUrl.includes('</iframe>')) {
                        // Detect audio format from URL
                        const urlLower = audioUrl.toLowerCase();
                        const isMP3 = urlLower.includes('.mp3');
                        const isAAC = urlLower.includes('.aac') || urlLower.includes('.m4a');

                        // console.log('✅ Using direct audio URL (radio_URL) instead of embed_url:', {
                        //     title: currentAudio?.title,
                        //     url: audioUrl,
                        //     format: isMP3 ? 'MP3' : isAAC ? 'AAC/M4A' : 'UNKNOWN',
                        //     source: currentAudio?.radio_URL ? 'radio_URL (PRIMARY)' :
                        //         currentAudio?.radio_url ? 'radio_url' :
                        //         currentAudio?.stream_url ? 'stream_url' :
                        //         currentAudio?.unified_audio_url ? 'unified_audio_url' :
                        //         currentAudio?.mp3_audio_upload ? 'mp3_audio_upload' :
                        //         currentAudio?.aac_audio_upload ? 'aac_audio_upload' :
                        //         currentAudio?.mp3_url ? 'mp3_url' :
                        //         currentAudio?.aac_audio_url ? 'aac_audio_url' : 'unknown',
                        //     browserSupport: {
                        //         mp3: document.createElement('audio').canPlayType('audio/mpeg'),
                        //         aac: document.createElement('audio').canPlayType('audio/aac'),
                        //         m4a: document.createElement('audio').canPlayType('audio/mp4')
                        //     }
                        // });
                        // We have a valid direct audio URL, proceed to use HTML5 audio player below
                    } else {
                        // No valid direct audio URL found, check for embed_url as fallback
                        if (currentAudio?.embed_url) {
                            // console.log('📺 No direct audio URL, using embed_url (iframe player):', {
                            //     title: currentAudio?.title,
                            //     embed_url: currentAudio.embed_url.substring(0, 100) + '...'
                            // });
                            return null; // Let MovableIframeRadioPlayer handle it
                        }
                        // No direct audio URL and no embed_url
                        audioUrl = null;
                    }
                } else {
                    // For regular music/audio
                    let rawUrl = currentAudio?.mp3_url ||
                        currentAudio?.aac_audio_url ||
                        currentAudio?.mp3_audio_upload ||
                        currentAudio?.aac_audio_upload ||
                        currentAudio?.unified_audio_url;

                    if (rawUrl && !rawUrl.startsWith('http')) {
                        if (rawUrl.startsWith('/play-audio/')) {
                            audioUrl = `${baseURL}${rawUrl}`;
                        } else {
                            audioUrl = `${baseURL}/play-audio/${rawUrl}`;
                        }
                    } else {
                        audioUrl = rawUrl;
                    }

                    // console.log('🎵 HTML5 Audio Music URL:', {
                    //     title: currentAudio?.title,
                    //     url: audioUrl
                    // });
                }

                if (!audioUrl) {
                    console.warn('⚠️ No valid audio URL found for:', currentAudio?.title);
                    return null;
                }

                const useAnonymousCors = shouldUseAnonymousCorsForAudio(audioUrl);

                return (
                    <audio
                        key={`${currentAudio?.id || currentAudio?.slug || 'audio'}-${useAnonymousCors ? 'cors' : 'plain'}-${audioUrl}`}
                        ref={(el) => {
                            playerRef.current = el;

                            // Connect to Web Audio graph if not already connected
                            if (el && audioContextRef.current && !sourceNodeRef.current && useAnonymousCors) {
                                try {
                                    sourceNodeRef.current = audioContextRef.current.createMediaElementSource(el);
                                    sourceNodeRef.current.connect(gainNodeRef.current);
                                    console.log('🔗 Audio element connected to GainNode for boost');
                                } catch (err) {
                                    console.warn('⚠️ Web Audio connection warning (expected if already connected):', err);
                                }
                            }
                        }}
                        src={audioUrl}
                        preload="auto"
                        crossOrigin={useAnonymousCors ? 'anonymous' : undefined}
                        style={{ display: 'none' }}
                        onLoadedMetadata={(e) => {
                            setDuration(e.target.duration);
                            // console.log('🎆 HTML5 Audio ready:', {
                            //     title: currentAudio?.title,
                            //     duration: e.target.duration
                            // });
                        }}
                        onTimeUpdate={(e) => {
                            setCurrentTime(e.target.currentTime * 1000);
                        }}
                        onEnded={() => {
                            // console.log('⏹️ Audio ended:', currentAudio?.title);
                            onAudioEnded();
                        }}
                        onPlay={() => {
                            // console.log('▶️ HTML5 Audio started playing:', currentAudio?.title);
                            setIsPlayerReady(true);

                            // Ensure AudioContext is running
                            if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
                                audioContextRef.current.resume();
                            }
                        }}
                        onPause={() => {
                            // console.log('⏸️ HTML5 Audio paused:', currentAudio?.title);
                        }}
                        onError={(e) => {
                            const urlLower = audioUrl.toLowerCase();
                            const format = urlLower.includes('.mp3') ? 'MP3' : urlLower.includes('.aac') ? 'AAC' : 'UNKNOWN';

                            console.error('🚨 HTML5 Audio Error (' + format + '):', {
                                title: currentAudio?.title,
                                url: audioUrl,
                                format: format,
                                error: e.target.error,
                                errorCode: e.target.error?.code,
                                errorMessage: e.target.error?.message,
                                errorName: e.target.error?.code === 1 ? 'MEDIA_ERR_ABORTED' :
                                    e.target.error?.code === 2 ? 'MEDIA_ERR_NETWORK' :
                                        e.target.error?.code === 3 ? 'MEDIA_ERR_DECODE' :
                                            e.target.error?.code === 4 ? 'MEDIA_ERR_SRC_NOT_SUPPORTED' : 'UNKNOWN',
                                possibleCauses: e.target.error?.code === 4 ?
                                    ['File format not supported', 'CORS issue', 'File not found', 'Server not accessible'] :
                                    e.target.error?.code === 3 ? ['File corrupted', 'Invalid format', 'Encoding issue'] :
                                        e.target.error?.code === 2 ? ['Network error', 'File not accessible', 'Server down'] : ['Unknown']
                            });
                            dispatch({ type: 'GET_PLAYING_SUCCESS', isPlaying: false });
                            // toast.error(`Cannot play ${format}: ${currentAudio?.title}`);
                        }}
                        onCanPlay={() => {
                            // console.log('✅ HTML5 Audio can play:', currentAudio?.title);
                            setIsPlayerReady(true);
                            // Auto-play if currentPlaying is true
                            if (currentPlaying && playerRef.current) {
                                playerRef.current.play().catch(err => {
                                    console.error('▶️ Autoplay failed:', err);
                                    // Browser blocked autoplay - user needs to click play
                                });
                            }
                        }}
                    />
                );
            })()}
            {siteTheme?.translate_checkout
                ? isTranslateLoading && <></>
                : null}
            {showOfflineAlert ? (
                <OnlineStatusAlert reload={reload} />
            ) : (
                !isOnline && <OnlineStatusAlert reload={reload} />
            )}
            {children}
        </MyContext.Provider>
    );
};

const mapStateToProps = state => ({
    currentAudio: state.get_current_Reducers.currentAudio,
    currentTimes: state.get_current_Reducers.currentTime,
    currentRepeat: state.get_current_Reducers.currentRepeat,
    playlistAudio: state.get_playlist_Reducer.playlistAudio,
    isLoading: state.get_playlist_Reducer.isLoading,
    error: state.get_playlist_Reducer.error,
    currentIndex: state.get_current_Reducers.currentIndex,
    currentPlaying: state.get_current_Reducers.currentPlaying,
    playlistShow: state.get_Playlist_Modal.playlistShow,
    homepage: state.get_Playlist_Modal.homepage,
    languageDetailsData: state.get_getUserTranslateLanguage_Reducer.languageDetailsData,
    minimize: state.get_Playlist_Modal.minimize,
    playlistData: state.get_current_Reducers.playlistData,
    actionType: state.get_current_Reducers.actionType,
    thumbnailFreeORCostLabel: state.get_allThumbnail_Reducer.thumbnailFreeORCostLabel,
    siteTheme: state.get_siteTheme_Reducer.siteTheme,
    isTranslateLoading: state.get_getUserTranslateLanguage_Reducer.isLoading,
    onlyPermission: state.get_userPermission_Reducer.onlyPermission,
});

export default connect(mapStateToProps)(MyProvider);

export function useMyContext() {
    return useContext(MyContext);
}
